import cl from './ContrastInfoBlock.module.scss'

export type ContrastInfoBlockProps = {
	title: string
	description: string
}

export const ContrastInfoBlock = ({ title, description }: ContrastInfoBlockProps): JSX.Element => (
	<section className={cl.section}>
		<div className={cl.block}>
			<h2 className={cl.title}>{title}</h2>
			<p className={cl.subtitle}>{description}</p>
		</div>
	</section>
)
